import { IResponseError } from "../web-request-factory/interfaces/IResponseError";

export class ResponseError extends Error implements IResponseError {
    public readonly code: string;

    constructor(code: string, message?: string) {
        super(message);
        this.code = code;
    }
}
